import React, { useContext } from "react";
import _ from "lodash";

export const PageDataContext = React.createContext();

function usePageData(key, params) {
  const pageData = useContext(PageDataContext) || {};
  const paramsClean = _.pickBy(params, v => !_.isNil(v));

  if (pageData[`${key}Res`] && _.isEqual(pageData[`${key}Res`].params || {}, paramsClean || {})) {
    return pageData[`${key}Res`].data;
  } else {
    return null;
  }
}

export default usePageData;
